import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTimerTransactionTypeSelect } from './useTimerTransactionTypeSelect';

interface TimerTransactionTypeSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the transaction type list is only fetched where the field is rendered. It
 * renders the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const TimerTransactionTypeSelect = ({
  onOpenPicker,
  onClear,
}: Readonly<TimerTransactionTypeSelectProps>) => {
  const { t } = useTranslation();
  const select = useTimerTransactionTypeSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('transaction:transactionType.transactionType')}
      placeholder={t('transaction:selectTransactionType')}
      searchPlaceholder={t('transaction:searchTransactionTypes')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="transactionType"
      data-testid="timer-transaction-type-button"
    />
  );
};

export default TimerTransactionTypeSelect;
